import { useDispatch, useSelector } from "react-redux"
import AnimatedPage from "../components/animatedPage"
import Banner from "../components/news/banner"
import ScrollToTop from "../components/scrollToTop"
import EventsCalendar from "../sections/eventsCalendar"
import OpinionArticle from "../sections/opinionArticle"
import OurLatestNews from "../sections/ourLatestNews"
import PastAnnualReports from "../sections/pastAnnualReports"
import { useEffect } from "react"
import { fetchEventsData } from "../redux/slice/NewAndEventsPage"
import { retrunAssets } from './../utils/getAssets';


const News = () => {

    const state = useSelector(state => state.events)
    const dispatch = useDispatch()

    useEffect(() => {
        if (state?.data === null) {
            dispatch(fetchEventsData("news-events"))
        }
    }, [state, dispatch])

    const events = state?.data?.properties
    const images = events?.newsBanner != null ? events?.newsBanner.map((item) => retrunAssets(item.url)) : []

    return (
        <AnimatedPage >
            {/* <ScrollToTop/> */}
            <Banner images={images} />
            <OurLatestNews events={events} />
            <OpinionArticle events={events} />
            <EventsCalendar events={events} />
            <PastAnnualReports events={events} />
        </AnimatedPage>
    )
}

export default News